export function versionedTeamsTree({ squads }) {
  return {
    squads: squads || [],
    searchTerm: "",
    searchTermPresent: false,
    expandedSquadIds: {},
    loaded: false,

    init() {
      const parentIds = new Set(
        this.squads.map((s) => s.parent_id).filter(Boolean),
      );
      // Initialize all squads as roots or with proper parent relationships
      this.squads = this.squads.map((squad) => ({
        ...squad,
        isRoot: !squad.parent_id,
        expanded: false,
        parentExpanded: false,
        is_parent: squad.is_parent || parentIds.has(squad.id),
      }));

      this.loaded = true;
    },

    get displayedSquads() {
      if (this.searchTermPresent) {
        return this.filterSquadsBySearch();
      }
      return this.squads;
    },

    search(event) {
      this.searchTerm = event.target.value;
      this.searchTermPresent = this.searchTerm.length > 0;
    },

    filterSquadsBySearch() {
      const searchLower = this.searchTerm.toLowerCase();
      const matchedSquadIds = new Set();
      const result = [];

      // First pass: find all matching squads
      this.squads.forEach((squad) => {
        if (
          squad.name.toLowerCase().includes(searchLower) ||
          squad.manager?.name?.toLowerCase().includes(searchLower) ||
          squad.manager?.email?.toLowerCase().includes(searchLower)
        ) {
          matchedSquadIds.add(squad.id);
        }
      });

      // Second pass: include all ancestors of matched squads
      matchedSquadIds.forEach((squadId) => {
        let currentSquad = this.squads.find((s) => s.id === squadId);
        while (currentSquad) {
          if (!matchedSquadIds.has(currentSquad.id)) {
            matchedSquadIds.add(currentSquad.id);
          }
          currentSquad = this.squads.find(
            (s) => s.id === currentSquad.parent_id,
          );
        }
      });

      // Build result with highlighting
      this.squads.forEach((squad) => {
        if (matchedSquadIds.has(squad.id)) {
          const highlightedSquad = { ...squad };

          // Highlight team name
          if (squad.name.toLowerCase().includes(searchLower)) {
            const index = squad.name.toLowerCase().indexOf(searchLower);
            const match = squad.name.substring(
              index,
              index + this.searchTerm.length,
            );
            highlightedSquad.highlightedName = squad.name
              .split(match)
              .join(`<span class="bg-yellow-100">${match}</span>`);
          }

          result.push(highlightedSquad);
        }
      });

      return result;
    },

    toggleSquad(targetSquad) {
      const squad = this.squads.find((s) => s.id === targetSquad.id);
      if (!squad) return;

      squad.expanded = !squad.expanded;
      this.expandedSquadIds[squad.id] = squad.expanded;

      // Update children's parentExpanded state
      this.squads.forEach((s) => {
        if (s.parent_id === squad.id) {
          s.parentExpanded = squad.expanded;
        }
      });

      // If collapsing, also collapse all descendants
      if (!squad.expanded) {
        this.collapseDescendants(squad.id);
      }
    },

    collapseDescendants(parentId) {
      this.squads.forEach((squad) => {
        if (squad.parent_id === parentId) {
          squad.expanded = false;
          squad.parentExpanded = false;
          delete this.expandedSquadIds[squad.id];
          this.collapseDescendants(squad.id);
        }
      });
    },
  };
}
